module.exports = __webpack_public_path__ + "static/segmentation-location-abce51d388c0486bc175f4d62e832d33.png";